exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /www/sms-simulator/sms-front/src/app/tagcloud/tagcloud.component.css
// module id = ../../../../../src/app/tagcloud/tagcloud.component.css
// module chunks = 1